import stickybits from 'stickybits';

function MainScript2() {

    const self = this;

    function initFixedHeader() {
        const header_mobile_toggle_btn = document.getElementById('header_mobile_toggle_btn');
        const header = document.getElementById('header');
        if (!header_mobile_toggle_btn || !header) {
            return false;
        }
        header_mobile_toggle_btn.addEventListener('click', (el) => {
            header.classList.toggle('mobile-open');
            document.body.classList.toggle('noscroll');
        });
        const mbtns = document.querySelectorAll('#top_nav .menu_item.menu_item_has_children .menu_link');
        for (let btn of mbtns) {
            btn.addEventListener('click', (el) => {
                if (window.innerWidth < 992) {
                    el.preventDefault();
                    let li = btn.parentElement;
                    li.classList.toggle('is-active');
                }
            });
        }
        stickybits(header);
    }

    function initMobileMenu() {
        const header = document.getElementById('header');
        for (const btn of document.querySelectorAll('.menu-item-has-children > a.menu_link')) {
            btn.addEventListener('click', (el) => {
                if (header.classList.contains('mobile-open')) {
                    el.preventDefault();
                    btn.classList.add('open-submenu');
                }
            });
        }
        for (const btn of document.querySelectorAll('.menu_sub_back')) {
            btn.addEventListener('click', (el) => {
                if (header.classList.contains('mobile-open')) {
                    el.preventDefault();
                    const li = btn.closest('.menu-item-has-children');
                    if (!li) {
                        return false;
                    }
                    const aLink = li.querySelector('a.menu_link');
                    if (!aLink) {
                        return false;
                    }
                    aLink.classList.remove('open-submenu');
                }
            });
        }
    }

    self.run = function() {
        initFixedHeader();
        initMobileMenu();
    }

}

const join_main_js2 = new MainScript2();
join_main_js2.run();